import React from "react";

const AppListHomeSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-black animate-pulse">
      {/* Banner */}
      <div className="w-full h-72 rounded-b-2xl bg-gray-300 dark:bg-gray-700 mb-8" />

      {/* Library Section 1 */}
      <div className="my-8 pl-4 space-y-4">
        <div className="w-3/5 h-8 mb-2 bg-gray-300 dark:bg-gray-700 rounded" />
        <div className="flex flex-row gap-4 mb-4 overflow-x-hidden">
          {Array.from({ length: 20 }).map((_, i) => (
            <div
              key={i}
              className="w-20 h-10 rounded bg-gray-300 dark:bg-gray-700 flex-shrink-0"
            />
          ))}
        </div>
        <div className="flex flex-row gap-4 overflow-x-hidden">
          {Array.from({ length: 20 }).map((_, i) => (
            <div
              key={i}
              className="w-60 h-80 rounded-lg bg-gray-300 dark:bg-gray-700 flex-shrink-0"
            />
          ))}
        </div>
      </div>

      {/* Library Section 2 */}
      <div className="my-8 pl-4 space-y-4">
        <div className="w-3/5 h-8 mb-2 bg-gray-300 dark:bg-gray-700 rounded" />
        <div className="flex flex-row gap-4 mb-4 overflow-x-hidden">
          {Array.from({ length: 20 }).map((_, i) => (
            <div
              key={i}
              className="w-20 h-10 rounded bg-gray-300 dark:bg-gray-700 flex-shrink-0"
            />
          ))}
        </div>
        <div className="flex flex-row gap-4 overflow-x-hidden">
          {Array.from({ length: 20 }).map((_, i) => (
            <div
              key={i}
              className="w-60 h-80 rounded-lg bg-gray-300 dark:bg-gray-700 flex-shrink-0"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppListHomeSkeleton;
